import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const ADD_DATA_SOURCE = registerQuery({
  fieldName: 'addDataSource',
  args: ['flowId', 'data'],
  fetcher: ({
    flowId,
    data
  }) => {
    return http.post(`automationplatform/v1/data-sources/flows/${flowId}`, {
      data
    });
  }
});